import _styled from "styled-components";
import { graphql, useFragment, type FragmentType } from "~/gql/runtime";
import { Link } from "~/features/ui/link";
import { takeFirst } from "~/features/app/utils";
import { type NavTheme } from "~/features/app/app-header-v2/context";
import { isLinkValid } from "~/features/ui/link/utils";
import { useLinkActive } from "~/features/ui/link/use-link-active";
const hoverStyle = {
  transparent: {
    "@media (hover: hover)": {
      "&:hover": {
        "backgroundColor": "rgba(0, 7, 4, 0.3)"
      },
      "&:hover::before": {
        "content": "var(--tw-content)",
        "opacity": "1"
      }
    }
  },
  solid: {
    "@media (hover: hover)": {
      "&:hover": {
        "--tw-bg-opacity": "1",
        "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))"
      },
      "&:hover::before": {
        "content": "var(--tw-content)",
        "opacity": "1"
      }
    }
  }
} as const;
const fragment = graphql(`
  fragment NavLink on navLinks_link_BlockType {
    link: baseLink {
      ...Link
    }
  }
`);
type Props = FragmentType<typeof fragment> & {
  theme: NavTheme;
};
export function NavLink(props: Props) {
  const {
    theme,
    ...rest
  } = props;
  const {
    link: _link,
    ..._rest
  } = useFragment(fragment, rest);
  const link = takeFirst(_link);
  const isActive = useLinkActive(link || undefined);
  if (!isLinkValid(link)) {
    return null;
  }
  return <_StyledLink {...link} {..._rest} $_css={[{
    "position": "relative",
    "display": "inline-flex",
    "height": "100%",
    "alignItems": "center",
    "justifyContent": "center",
    "textAlign": "center",
    "transitionProperty": "color, background-color, border-color, text-decoration-color, fill, stroke",
    "transitionDuration": "250ms",
    "transitionTimingFunction": "ease-in-out"
  }, {
    "&::before": {
      "content": "var(--tw-content)",
      "position": "absolute",
      "left": "0",
      "right": "0",
      "top": "0",
      "height": "0.4rem",
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(75 46 248 / var(--tw-bg-opacity))",
      "opacity": "0",
      "transitionProperty": "opacity",
      "transitionDuration": "250ms",
      "transitionTimingFunction": "ease-in-out",
      "--tw-content": "\"\""
    }
  }, isActive && {
    "&::before": {
      "content": "var(--tw-content)",
      "opacity": "1"
    }
  }, hoverStyle[theme]]} />;
}
var _StyledLink = /*#__PURE__*/_styled(Link).withConfig({
  displayName: "nav-link___StyledLink",
  componentId: "sc-1f1g9zv-0"
})(["", ""], p => p.$_css);